<router-outlet></router-outlet>
<!-- Sentry test button - uncomment to test error reporting -->
<!-- <button (click)="throwTestError()">Test Sentry Error</button> -->
